import React from 'react'
import Title from './Title'

function Blog() {
  return (
    <div>
      <Title title="No Blog Posted yet wait for few days"/>
    </div>
  )
}

export default Blog
